import { render, staticRenderFns } from "./ReviewApplication.vue?vue&type=template&id=0dc73e20&scoped=true"
import script from "./ReviewApplication.vue?vue&type=script&lang=js"
export * from "./ReviewApplication.vue?vue&type=script&lang=js"
import style0 from "./ReviewApplication.vue?vue&type=style&index=0&id=0dc73e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc73e20",
  null
  
)

export default component.exports